import Swiper, { EffectFade, Navigation } from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const doubleBoxSwiper = 'double-box__swiper';
const swiperWrappers = document.getElementsByClassName(doubleBoxSwiper);
let swipers = [];
let width = window.innerWidth;

function swiperInit(container) {
  let options = {
    loop: false,
    autoHeight: false,
    height: 605,
  };

  if (window.innerWidth > breakpoints.xl) {
    options = {
      ...options,
      modules: [EffectFade],
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: false,
      },
    };
  } else {
    options = {
      ...options,
      modules: [Navigation],
      allowTouchMove: true,
      navigation: {
        nextEl: container.querySelector('.js-swiper-btn-next'),
        prevEl: container.querySelector('.js-swiper-btn-prev'),
      },
    };
  }

  // eslint-disable-next-line no-new
  const swiper = new Swiper(container, options);
  swipers.push(swiper);
}

window.document.addEventListener('DOMContentLoaded', () => {
  if (swiperWrappers.length > 0) {
    for (let i = 0; i < swiperWrappers.length; i++) {
      swiperInit(swiperWrappers[i]);
    }
  }
});

const doubleBoxEnter = (event) => {
  const swiperElement = event.target.closest(`.${doubleBoxSwiper}`);
  if (window.innerWidth > breakpoints.xl && swiperElement && !swiperElement.classList.contains('activeHover')) {
    swiperElement.classList.add('activeHover');
    swiperElement.swiper.slideNext();
  }
};

const doubleBoxLeave = (event) => {
  const swiperElement = event.target.closest(`.${doubleBoxSwiper}`);
  if (window.innerWidth > breakpoints.xl && swiperElement && swiperElement.classList.contains('activeHover')) {
    swiperElement.classList.remove('activeHover');
    swiperElement.swiper.slidePrev();
  }
};

for (let i = 0; i < swiperWrappers.length; i++) {
  swiperWrappers[i].addEventListener('mouseout', doubleBoxLeave);
  swiperWrappers[i].addEventListener('mouseover', doubleBoxEnter);
}

window.addEventListener('resize', () => {
  if (window.innerWidth !== width) {
    width = window.innerWidth;

    swipers.forEach((swiper) => {
      swiper.destroy(true, true);
    });

    swipers = [];

    setTimeout(() => {
      if (swiperWrappers.length > 0) {
        for (let i = 0; i < swiperWrappers.length; i++) {
          swiperInit(swiperWrappers[i]);
        }
      }
    }, 300);
  }
});
